import React from 'react';
import _ from 'lodash';
import Tooltip from '../components/carousel/ToolTip';
import * as ACTIONS from '../actions/tooltip';

const initialState = {
  getTooltip: {},
};

export default function metrics(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_TOOLTIP_DATA:
      const { __id, tooltipData, event } = action.toolTipData;

      // WTF 🚨
      // event is a SyntheticEvent
      // if (event.target.className != 'play') return state;
      if (event && !('target' in event)) return state;
      const className = _.get(event, ['target', 'className']);

      if (className !== 'play') return state;

      if (!__id) {
        return Object.assign({}, state, {
          getTooltip: {},
        });
      }

      const w = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0,
      );
      const h = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0,
      );
      let xoffset = 300;
      let yoffset = 80;

      if (event.target && event.target.clientWidth) {
        xoffset = event.target.clientWidth + 10;

        if (event.pageX > w - event.pageX) {
          xoffset = -event.target.clientWidth - 30;
        }
        if (event.pageY > h - event.pageY) {
          yoffset = -event.target.clientHeight - 30;
        }
      }

      /** *******************************************************
          window.pageYOffset -  compatibility with IE and EDGE
      ******************************************************** */
      const supportPageOffset = window.pageYOffset !== undefined;
      const yScroll = supportPageOffset ? window.pageYOffset : window.scrollY;

      const cuadro = event.target.getBoundingClientRect();
      yoffset = yScroll + cuadro.top + cuadro.height / 4;
      xoffset = cuadro.right + 5;

      let withRi = null;
      if (xoffset + 330 > window.innerWidth && window.innerWidth > 330) {
        withRi = true;
        xoffset = cuadro.left - 335;
      }

      window.avoidTooltilTimer = false;

      event.target.addEventListener(
        "mouseover",
        _.debounce(
          () => {
            if (window.openToolTip) clearTimeout(window.openToolTip);
            window.openToolTip =  setTimeout(() => {
              $('.ToolTip-Container').show();
            }, 1500)
          },
          1500,
          { leading: true, trailing: false }
        )
      );

      event.target.addEventListener(
        "mouseleave",
        _.debounce(
          () => {
            if (window.closeToolTip) clearTimeout(window.closeToolTip);
            window.closeToolTip = setTimeout(() => {
              $('.ToolTip-Container').hide();    
            }, 1500)
          },
          1500,
          { leading: true, trailing: false }
        )
      );

      $('#tooltip').mouseover( () => {
            if (window.closeToolTip) clearTimeout(window.closeToolTip);
            $('.ToolTip-Container').show();
      });

      $('#tooltip').mouseleave( 
          () => {
            if (window.openToolTip) clearTimeout(window.openToolTip);
            $('.ToolTip-Container').hide();
          },
      );
      
      const tooltipComponent = (
        <Tooltip
          tooltipData={tooltipData}
          x={xoffset}
          y={yoffset}
          withRi={withRi}
        />
      );

      const getTooltip = {
        __id,
        tooltipComponent,
      };

      return Object.assign({}, state, {
        getTooltip,
      });
    case ACTIONS.CLEAN_TOOLTIP_DATA:
        return {
          getTooltip: {},
        }
    default:
      return state;
  }
}
